export const fieldsBasicDataCertificate = {
  surname: {
    key: "surname",
    label: "Фамилия",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
  },
  name: {
    key: "name",
    label: "Имя",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
  },
  midname: {
    key: "midname",
    label: "Отчество",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
  },
  birthDate: {
    key: "birthDate",
    label: "Дата рождения",
    type: "date",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
    customValidation(value) {
      const today = new Date();
      const birthDate = new Date(value);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 18) {
        return "Владелец удостоверения должен быть старше 18 лет";
      } else {
        return true;
      }
    },
  },
  birthPlace: {
    key: "birthPlace",
    label: "Место рождения",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
  },
  residence: {
    key: "residence",
    label: "Гражданство",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
  },
  surnameEn: {
    key: "surnameEn",
    label: "Surname",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[a-zA-Z\s.,;:!?'"-]*$/,
      message: `Заполнение на английском языке`,
    },
  },
  nameEn: {
    key: "nameEn",
    label: "Name",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[a-zA-Z\s.,;:!?'"-]*$/,
      message: `Заполнение на английском языке`,
    },
  },
  birthPlaceEn: {
    key: "birthPlaceEn",
    label: "Place of birth",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[a-zA-Z\s.,;:!?'"-]*$/,
      message: `Заполнение на английском языке`,
    },
  },
  residenceEn: {
    key: "residenceEn",
    label: "Residence",
    type: "text",
    readOnly: true,
    needInForm: true,
    placeholder: "Введите",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[a-zA-Z\s.,;:!?'"-]*$/,
      message: `Заполнение на английском языке`,
    },
  },
};

export const setupOptionsBasicDataCertificateByCertificateType = (typeId) => {
  if (typeId) {
    if (Number(typeId) === 1) {
      for (let item in fieldsBasicDataCertificate) {
        if (fieldsBasicDataCertificate[item].key.includes("En")) {
          fieldsBasicDataCertificate[item].needInForm = false;
        }
      }
      // fieldsBasicDataCertificate.En
    } else {
      for (let item in fieldsBasicDataCertificate) {
        if (fieldsBasicDataCertificate[item].key.includes("En")) {
          fieldsBasicDataCertificate[item].needInForm = true;
        }
      }
    }
    return fieldsBasicDataCertificate;
  }
};
